import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

// import ArticleInspirationStyleCard from './Article/ArticleInspirationStyleCard';
// import ArticleNormalStyleCard from './Article/ArticleNormalStyleCard';
import Link from '~/components/Link/Link';

const ArticleInspirationStyleCard = dynamic(() => import(/* webpackChunkName: "Card.ArticleInspirationStyleCard.components" */'./Article/ArticleInspirationStyleCard'), { loading: () => null });
const ArticleNormalStyleCard = dynamic(() => import(/* webpackChunkName: "Card.ArticleNormalStyleCard.components" */'./Article/ArticleNormalStyleCard'), { loading: () => null });

const ArticleCard = props => {
  const { data, inspirationStyle } = props;
  return (
    <Link to={data.slug ? `/article/${data.slug}` : '/'} className="link">
      {inspirationStyle
        ? <ArticleInspirationStyleCard data={data} />
        : <ArticleNormalStyleCard data={data} />
      }
    </Link>
  );
};

ArticleCard.propTypes = {
  data: PropTypes.array,
  inspirationStyle: PropTypes.bool
};

export default ArticleCard;
